import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CircleCheckIcon, XIcon } from 'lucide-react';
import { images, recentBuyers } from '../data/content';
const SHOW_MS = 5000;
const GAP_MS = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const first = window.setTimeout(() => setOpen(true), 6000);
    const cycle = window.setInterval(() => {
      setIndex(i => (i + 1) % recentBuyers.length);
      setOpen(true);
      hideTimer = window.setTimeout(() => setOpen(false), SHOW_MS);
    }, SHOW_MS + GAP_MS);
    const firstHide = window.setTimeout(() => setOpen(false), 6000 + SHOW_MS);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(firstHide);
      window.clearTimeout(hideTimer);
      window.clearInterval(cycle);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  const minutesAgo = index % 9 + 2;
  return <AnimatePresence data-id="element-22" data-mp="1164no5mh8s1t">
      {open && !dismissed && <motion.div key={index} initial={{
      opacity: 0,
      x: -24,
      scale: 0.96
    }} animate={{
      opacity: 1,
      x: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      x: -24,
      scale: 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-[88px] left-3 z-50 w-[calc(100%-24px)] max-w-[340px] sm:bottom-4 sm:left-4" role="status" aria-live="polite" data-id="element-23" data-mp="1fvsn11b3lgmw">
          <div className="relative flex items-center gap-3 rounded-2xl border border-ink/10 bg-white p-3 pr-9 shadow-[0_12px_32px_rgba(11,27,46,0.22)]" data-id="element-24" data-mp="x62ktt509sky">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-lg bg-cream object-contain" data-id="element-25" data-mp="28kg2uhd2vdt2" />
            <div className="min-w-0" data-id="element-26" data-mp="23lwgifuko006">
              <p className="text-sm leading-snug text-ink" data-id="element-27" data-mp="23kv4o95qf9he">
                <span className="font-bold" data-id="element-28" data-mp="2ap2yj3htke80">{buyer.name}</span> from <span className="font-bold" data-id="element-29" data-mp="2aobg6ud8gczo">{buyer.country}</span>
              </p>
              <p className="text-sm leading-snug text-ink/80" data-id="element-30" data-mp="2fmd0tjqb4kd9">just purchased Picking Control 30™</p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-success" data-id="element-31" data-mp="2knadxhwgmo7w">
                <CircleCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-32" data-mp="2pkiuxf5vgm7k" />
                {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-ink/50 transition-colors duration-150 hover:text-ink" aria-label="Close notification" data-id="element-33" data-mp="1wx6dtkihd6ln">
              <XIcon className="h-4 w-4" data-id="element-34" data-mp="26osuvxhi1zwb" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}